import { AxiosResponse } from 'axios';
import { USERS_API_URL } from '../../../../config';
import brokersAxios from '../../../../utils/axios/brokers-roles.axios';
import { PaginatedTeamMembers } from '../../../../interfaces/teams/paginatedStore.type';

const tryToFetchTeamMembers = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<PaginatedTeamMembers>> => {
    const url = filters
        ? `${USERS_API_URL}/rebecca-users/users/by-company?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${USERS_API_URL}/rebecca-users/users/by-company?page=${pageNumber}&size=${pageSize}`;
    return brokersAxios.put<PaginatedTeamMembers>(url, data);
};

const tryToFetchAllTeamMembers = (data: any): Promise<AxiosResponse<any>> => {
    const url = `${USERS_API_URL}/rebecca-users/users/by-company/all`
    return brokersAxios.put(url, data);
};

const tryToFetchSingleTeamMember = (id: string): Promise<AxiosResponse<any>> => {
    return brokersAxios.get(`${USERS_API_URL}/rebecca-users/users/by-company/${id}`);
};

const tryToDeleteTeamMembers = (data: any): Promise<AxiosResponse<any>> => {
    return brokersAxios.put(`${USERS_API_URL}/rebecca-users/users/by-company/offboard-users`, data);
};

export const TeamsService = {
    tryToFetchTeamMembers,
    tryToFetchAllTeamMembers,
    tryToFetchSingleTeamMember,
    tryToDeleteTeamMembers
};